/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import DefaultUserFunIcon from "../../../../../shared-assets/images/funUgc/DefaultUserFunIcon.png";
import { HomeItem, UGCList } from "../../../../models/home-rows";
import { ROUTES } from "../../../../services/router-services";
import PlusIcon from "./../../../../../shared-assets/images/funUgc/Ugc-PlusIcon.png";
import styles from "./funUGC.module.scss";
import { useFetchNextPage } from "./hooks/useFetchNextPage";
import FunUGCModal from "./modal/funUGCModal.component";

interface FunUGCProps {
  homeItem: HomeItem;
}

const FunUGC = ({ homeItem }: FunUGCProps) => {
  return (
    <>
      <div className={styles.mainWrapper}>
        {homeItem.banner.bg_img && (
          <div className={styles.bg}>
            <Image
              src={homeItem.banner.bg_img}
              alt=""
              layout="fill"
              priority={true}
            />
          </div>
        )}

        <div className={styles.wrapper}>
          <div
            className={styles.wrapperTitle}
            style={{ color: homeItem.banner.bg_color || "white" }}
          >
            {homeItem.title}
          </div>

          <div className={styles.itemsWrapper}>
            <a href={ROUTES.funDownloadPage}>
              <div className={styles.createFunWrapper}>
                <div className={styles.plusIcon}>
                  <Image src={PlusIcon} alt="" layout="fill" priority={true} />
                </div>
              </div>
            </a>

            <FunItems homeItem={homeItem} />
          </div>
        </div>
      </div>
    </>
  );
};

export default FunUGC;

interface FunItemsProps {
  homeItem: HomeItem;
}

const FunItems = ({ homeItem }: FunItemsProps) => {
  const breakpoints = {
    // ===> Desktop
    2700: {
      slidesPerView: 15,
      spaceBetween: 0
    },
    2000: {
      slidesPerView: 13.5,
      spaceBetween: 0
    },
    1800: {
      slidesPerView: 10.5,
      spaceBetween: 0
    },
    1600: {
      slidesPerView: 9.5,
      spaceBetween: 0
    },
    1400: {
      slidesPerView: 9,
      spaceBetween: 0
    },
    1270: {
      slidesPerView: 7.5,
      spaceBetween: 0
    },
    1210: {
      slidesPerView: 7,
      spaceBetween: 0
    },
    1135: {
      slidesPerView: 6.5,
      spaceBetween: 0
    },
    1170: {
      slidesPerView: 6,
      spaceBetween: 0
    },
    1007: {
      slidesPerView: 5.5,
      spaceBetween: 0
    },
    938: {
      slidesPerView: 5,
      spaceBetween: 0
    },
    878: {
      slidesPerView: 4.5,
      spaceBetween: 0
    },
    848: {
      slidesPerView: 4.25,
      spaceBetween: 0
    },
    815: {
      slidesPerView: 4,
      spaceBetween: 0
    },
    800: {
      slidesPerView: 3.75,
      spaceBetween: 0
    },
    769: {
      slidesPerView: 3.75,
      spaceBetween: 0
    },

    // ===> Mobile
    700: {
      slidesPerView: 8.5,
      spaceBetween: 0
    },
    680: {
      slidesPerView: 8,
      spaceBetween: 0
    },
    640: {
      slidesPerView: 7.5,
      spaceBetween: 0
    },
    620: {
      slidesPerView: 7.2,
      spaceBetween: 0
    },
    600: {
      slidesPerView: 7,
      spaceBetween: 0
    },
    565: {
      slidesPerView: 6.5,
      spaceBetween: 0
    },
    545: {
      slidesPerView: 6.25,
      spaceBetween: 0
    },
    525: {
      slidesPerView: 6,
      spaceBetween: 0
    },
    485: {
      slidesPerView: 5.5,
      spaceBetween: 0
    },
    465: {
      slidesPerView: 5.25,
      spaceBetween: 0
    },
    445: {
      slidesPerView: 5,
      spaceBetween: 0
    },
    425: {
      slidesPerView: 4.75,
      spaceBetween: 0
    },
    400: {
      slidesPerView: 4.25,
      spaceBetween: 0
    },
    385: {
      slidesPerView: 4,
      spaceBetween: 0
    },
    365: {
      slidesPerView: 3.75,
      spaceBetween: 0
    },
    345: {
      slidesPerView: 3.5,
      spaceBetween: 0
    },
    325: {
      slidesPerView: 3.25,
      spaceBetween: 0
    },
    300: {
      slidesPerView: 3,
      spaceBetween: 0
    },

    285: {
      slidesPerView: 2.75,
      spaceBetween: 0
    },
    265: {
      slidesPerView: 2.5,
      spaceBetween: 0
    },
    245: {
      slidesPerView: 2.25,
      spaceBetween: 0
    },
    225: {
      slidesPerView: 2,
      spaceBetween: 0
    },
    200: {
      slidesPerView: 1.75,
      spaceBetween: 0
    },
    160: {
      slidesPerView: 1.25,
      spaceBetween: 0
    },
    100: {
      slidesPerView: 1,
      spaceBetween: 0
    }
  };

  const [homeItemMain, setHomeItemMain] = useState<HomeItem | null>(homeItem);
  const [showUgcModal, setShowUgcModal] = useState(false);
  const [ugc, setUgc] = useState<UGCList>();
  const [ugcIndex, setUgcIndex] = useState(0);

  const { fetchNextPage, output } = useFetchNextPage(homeItemMain);
  const router = useRouter();
  const UgcSetter = async (ugc: UGCList, ugcIndex: number) => {
    setUgc(ugc);
    setUgcIndex(ugcIndex);
  };

  const handleReachEnd = async () => {
    if (!homeItemMain || !homeItemMain.next) return;

    await fetchNextPage();
  };

  useEffect(() => {
    setHomeItemMain(output);
  }, [output]);

  useEffect(() => {
    if (!router.isReady) return;
    const { ugcId, rowMode } = router.query;

    if (String(homeItemMain.row_mode) === rowMode && !showUgcModal) {
      const index = homeItemMain.ugc_list.findIndex(item => item.id === +ugcId);

      if (index === -1) return;
      setUgcIndex(index);
      setShowUgcModal(true);
    }
  }, [router.isReady]);

  return (
    <>
      {showUgcModal && (
        <FunUGCModal
          ugcIndex={ugcIndex}
          homeItem={homeItemMain}
          setHomeItem={setHomeItemMain}
          setShowUgcModal={setShowUgcModal}
        />
      )}

      <Swiper
        className={styles.funWrapper}
        autoHeight={false}
        slidesPerView={8.5}
        slidesPerGroup={1}
        dir="rtl"
        breakpoints={breakpoints}
        onReachEnd={handleReachEnd}
      >
        {homeItemMain &&
          homeItemMain.ugc_list.map((item, index) => {
            return (
              item && (
                <SwiperSlide
                  key={"fun-ugc-item-" + item.id + index * 257.3}
                  virtualIndex={index}
                >
                  {item.user && item.user.avatar && (
                    <div className={styles.funSliderWrapper}>
                      <div className={styles.funSlider}>
                        <Image
                          src={item.user.avatar}
                          alt={""}
                          onClick={async () => {
                            await UgcSetter(item, index);

                            setShowUgcModal(true);
                          }}
                          layout="fill"
                        />
                      </div>
                    </div>
                  )}

                  {!item.user && !item.user?.avatar && (
                    <div className={styles.funSliderDefaultWrapper}>
                      <div className={styles.funSliderDefault}>
                        <Image
                          src={DefaultUserFunIcon}
                          alt={""}
                          onClick={async () => {
                            await UgcSetter(item, index);

                            setShowUgcModal(true);
                          }}
                          layout="fill"
                        />
                      </div>
                    </div>
                  )}
                </SwiperSlide>
              )
            );
          })}
      </Swiper>
    </>
  );
};
